import * as React from 'react';
import Radium from '../../../../rostelecom/styling/rostelecom-radium';
import dialogsStore, { IStoredDialogState } from '../../../../../../services/dialogs/dialogs-store';
import { IRostelecomStyleParamsStoreState } from '../../../../rostelecom/styling/rostelecom-styles-store';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import RostelecomDialogContainer from '../../../../rostelecom/dialogs/dialog-container/rostelecom-dialog-container';
import dialogsActions from '../../../../../../services/dialogs/dialogs-actions';
import RostelecomDialogFooter from '../../../../rostelecom/dialogs/dialog-container/rostelecom-dialog-footer';
import { tosRequests } from '../../../../../../services/tos/tos-requests';
import { ILoginStoreState } from '../../../../../../services/login/login-store';
import settingsStore from '../../../../../../services/settings/settings-store';
import { ISettingsStoreState } from '../../../../../../services/settings/settings-types';

export interface IAcceptToSDialogData {
    tosText: string;
}

interface IProps {
    styles: IRostelecomStyleParamsStoreState;
    loginStore: ILoginStoreState;
}

interface IState {
    checked: boolean;
    tosText: string;
    dialog: IStoredDialogState<IAcceptToSDialogData>;
    settings: ISettingsStoreState;
}

export const tosDialogId = 'tosDialog';
const i18nPrefix = `js.components.dialogs.accept-tos.`;

@Radium
export class AcceptTosDialog extends InternationalizedComponent<IProps, IState> {
    constructor(props: IProps, state: IState) {
        super(props, state);

        this.stores = {
            dialog: dialogsStore.getDialogStore(tosDialogId),
            settings: settingsStore
        };

        this.initialize();

        this.state = { ...this.state, checked: false };
    }

    private close = () => {
        dialogsActions.hideAndResetDialog(tosDialogId);
    };

    private getStyles(): { [style: string]: React.CSSProperties } {
        const styleParams = this.props.styles;

        return {
            btnStyle: {
                color: styleParams.baseLightColor,
                backgroundColor: styleParams.baseMediumDarkColor,
                cursor: 'pointer',
                border: 'none',
                borderRadius: 0,
                width: '120px',
                fontSize: '12px',
                padding: '8px',
                textAlign: 'center',
                lineHeight: '15px',
                fontWeight: 'normal',
                textDecoration: 'none',
                transition: 'background-color 0.15s ease-out, color 0.15s ease-out',
                display: 'inline-block',
                height: 31
            }
        };
    }

    private onAccept = async (evt: React.MouseEvent<HTMLButtonElement>) => {
        try {
            await tosRequests.acceptTos();
            const redirectTo = this.props.loginStore.redirectTo || '/';
            if (typeof window !== 'undefined') {
                window.location.replace(redirectTo);
            }
        } catch (e) {
            console.error(e);
        }
    };

    public render(): JSX.Element {
        const styles = this.getStyles();
        const isVisible = this.state.dialog.visible;
        const agreementText = (this.state.dialog.data && this.state.dialog.data.tosText) || '';
        const logoutPath = (this.state.settings.sources.paths || {}).logout || '/logout/index';

        const declineBtnStyle = { ...styles.btnStyle, marginLeft: 10 };
        return (
            <RostelecomDialogContainer
                {...{
                    visible: isVisible,
                    allowClose: false,
                    addPadding: true,
                    width: 900,
                    height: 900,
                    onClose: this.close,
                    processing: false,
                    styles: this.props.styles
                }}
            >
                <div
                    style={{ textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: agreementText }}
                />
                <RostelecomDialogFooter styles={this.props.styles}>
                    <button onClick={this.onAccept} key="accept" style={styles.btnStyle}>
                        {this.i18n(i18nPrefix + 'accept')}
                    </button>
                    <a href={logoutPath} key="decline" style={declineBtnStyle}>
                        {this.i18n(i18nPrefix + 'decline')}
                    </a>
                </RostelecomDialogFooter>
            </RostelecomDialogContainer>
        );
    }
}
